<template>
  <div ref="store" class="b-store">
    <div v-if="showCloseButton" class="b-store__close">
      <button type="button" class="btn btn-clear" @click="onClickClose">
        <i class="icon-close-light"></i>
      </button>
    </div>

    <div class="b-store__picture">
      <LazyImage
        v-if="item.image"
        :image="item.image"
        class="object-fit-cover" />
    </div>
    <div class="b-store__info">
      <div class="b-store__title">{{ item.address }}, {{ item.city }}</div>
      <div class="b-store__contact">
        <a :href="'tel:' + item.phone">
          <i class="icon-phone-call"></i>
          <span>{{ item.phoneStripDialingCode }}</span>
        </a>

        <div
          data-bs-toggle="tooltip"
          data-bs-html="true"
          :title="item.scheduleAsList">
          <i class="icon-clock"></i>
          <span>{{ dictionary.workingHours }}</span>

          <LazyImage
            :image="{
              url: '/imgs/icons/tooltip.svg',
            }"
            width="15" />
        </div>
      </div>
      <div class="b-store__button">
        <Anchor
          v-if="item.bookLink"
          :item="item.bookLink"
          class="btn btn-primary btn-full-width"></Anchor>
        <button
          v-else
          type="button"
          class="btn btn-primary btn-full-width"
          @click="onSelectStore">
          {{ dictionary.buttonSelectStoreText }}
        </button>
      </div>
    </div>
    <div class="b-store__link">
      <Anchor
        v-if="navigationLink"
        :item="navigationLink"
        class="btn btn-link btn-icon-end btn-forward strong">
        <i class="icon-arrow-long-right"></i>
      </Anchor>
    </div>
  </div>
</template>

<script>
import Anchor from './common/Anchor.vue'
import LazyImage from './common/LazyImage.vue'
import * as lib from './../../lib/lib'

export default {
  components: { Anchor, LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
    showCloseButton: {
      required: false,
      type: Boolean,
    },
  },
  emits: ['clear-selected-record'],
  computed: {
    navigationLink() {
      return {
        url: `https://www.google.com/maps/dir/?api=1&destination=${this.item.longitude},${this.item.latitude}`,
        text: this.dictionary.buttonNavigateText,
        target: '_blank',
        external: false,
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      lib.iniTooltips(this.$refs.store)
    })
  },
  updated() {
    this.$nextTick(() => {
      lib.iniTooltips(this.$refs.store)
    })
  },
  methods: {
    onSelectStore() {
      document.dispatchEvent(
        new CustomEvent('chooseStore', { detail: { status: this.item } })
      )
    },
    onClickClose() {
      this.$emit('clear-selected-record')
    },
  },
}
</script>
